import { 
  doc, 
  getDoc, 
  updateDoc,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './firebase-config';
import { AdminSettings, Reward } from '../types';

export const getEstablishmentSettings = async (establishmentId: string): Promise<AdminSettings | null> => {
  try {
    const establishmentRef = doc(db, 'establishments', establishmentId);
    const establishmentDoc = await getDoc(establishmentRef);
    
    if (establishmentDoc.exists()) {
      return establishmentDoc.data().settings as AdminSettings;
    }
    return null;
  } catch (error: any) {
    console.error('Get establishment settings error:', error);
    throw new Error(error.message || 'Erro ao buscar configurações');
  }
};

export const updateEstablishmentSettings = async (establishmentId: string, settings: AdminSettings): Promise<void> => {
  try {
    const establishmentRef = doc(db, 'establishments', establishmentId);
    const establishmentDoc = await getDoc(establishmentRef);
    
    if (!establishmentDoc.exists()) {
      throw new Error('Estabelecimento não encontrado');
    }

    // Ensure each reward has the correct establishmentId and creation timestamp
    const updatedSettings: AdminSettings = {
      ...settings,
      rewards: settings.rewards.map((reward: Reward) => ({
        ...reward,
        establishmentId,
        createdAt: reward.createdAt || serverTimestamp()
      }))
    };

    await updateDoc(establishmentRef, { 
      settings: updatedSettings,
      updatedAt: serverTimestamp()
    });
  } catch (error: any) {
    console.error('Update establishment settings error:', error);
    throw new Error(error.message || 'Erro ao atualizar configurações');
  }
};